<!--问诊问卷填空题-->
<template>
  <!--<div v-rules="rules">-->
  <div>
    <div class="m-input-box" >
      <input class="m-input" :type="type==='text'?'text':mType" :value="value" :dataList="dataList" :placeholder="placeholder" :disabled="disabled"
             :maxlength="maxlength"  @input="handleInput" id="input"/>
    </div>
    <p class="m-msg">{{errMsg}}</p>
  </div>
</template>

<script>

export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {},
    placeholder: {
      type: String,
      default: '请输入...'
    },
    maxlength: {
      type: Number,
      default: 20
    },
    startNum: {
      type: String,
      default: ''
    },
    endNum: {
      type: String,
      default: ''
    },
    NumType: {
      type: String,
      default: ''
    },
    dataList: {
      type: Object
    }
  },
  data () {
    return {
      inputModel: this.value,
      errMsg: '',
      mType: 'text'
    }
  },
  created () {

  },
  methods: {
    handleInput (event) {
      let value = event.target.value
      let state = true
      let errMsg = `输入值不能超过${this.startNum}-${this.endNum}范围`
      if (this.mType === 'tel' && (this.endNum || this.startNum)) {
        if ((/^\d+$/g.test(value))) {
          if (parseInt(value) > parseInt(this.endNum)) {
            this.errMsg = errMsg
          } else if (parseInt(value) < parseInt(this.startNum)) {
            this.errMsg = errMsg
          } else {
            this.errMsg = ''
          }
        } else {
          this.errMsg = `请输入${this.startNum}-${this.endNum}之间的整数`
        }
      }
      if (this.mType === 'number' && (this.endNum || this.startNum)) {
        if (parseFloat(value) > parseFloat(this.endNum)) {
          this.errMsg = errMsg
        } else if (parseFloat(value) < parseFloat(this.startNum)) {
          this.errMsg = errMsg
        } else {
          this.errMsg = ''
        }
      }
      if (this.errMsg !== '' || value === '') {
        state = false
      }
      this.$emit('input', value, state, this.dataList) //触发 input 事件，并传入新值
    }
  },
  watch: {
    'inputModel' (newv) {
      console.log(newv)
    },
    type: {
      handler (newValue, oldValue) {
        //父组件param对象改变会触发此函数
        if (newValue === 'number') {
          this.mType = 'tel'
        } else if (newValue === 'double') {
          this.mType = 'number'
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
.m-input-box {
  > input {
    width: 100%;
    height: 34px;
    padding-left: 20px;
    border-radius: 9px;
    font-size: 14px;
    border: 1px solid #dddddd;
  }
}

.m-msg {
  width: 100%;
  line-height: 20px;
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  color: #ff0000;
  .icon {
    padding-right: 10px;
    font-size: 22px;
  }
}
</style>
